var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 42c-4 0-8-3-8-8s4-9 8-9h390c5 0 8 4 8 9s-3 8-8 8H8zm85 170c-5 0-8-4-8-9 0-4 3-8 8-8h220c5 0 9 4 9 8 0 5-4 9-9 9H93zm85 169c-5 0-9-4-9-9 0-4 4-8 9-8h51c4 0 8 4 8 8 0 5-4 9-8 9h-51z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterList);
export default __webpack_public_path__ + "static/media/FilterList.1ceab8ae8f44c60dd3e6b423a9f21997.svg";
export { ForwardRef as ReactComponent };